import React from 'react';
import {fetchStaticPage} from '../../../actions/globalConfig';
import {connect} from 'react-redux';

class StaticModalView extends React.Component {

  constructor(props){
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.generateHtml = this.generateHtml.bind(this);
  }

  componentDidMount(){
      this.props.dispatch(fetchStaticPage(this.props.contentType));
  }

  closeModal (e){
    e.preventDefault();
    this.props.removeModal();
  }
  generateHtml () {
    return {__html: typeof this.props.pageContent === 'string' ? this.props.pageContent : this.props.pageContent.html};
  }

  render(){
    if (!this.props.pageContent) return null;
    return (
      <div className="p-30">
          <a className="close-modal float-right" onClick={this.closeModal}><i className="icon-X_Close_Square"></i></a>
          <h2 className="text-uppercase">{this.props.pageTitle}</h2>
          <div className="p-3" style={{'height': '600px', 'overflow-y': 'scroll'}}>
            <div className="text-justify" dangerouslySetInnerHTML={this.generateHtml()} />
          </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    contentType: ownProps.contentType,
    pageTitle: ownProps.pageTitle,
    pageContent: state.globalConfig.pageContent
  };
}

export default connect(mapStateToProps)(StaticModalView);
